import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'rsuite';
import { LinkButton } from '../../../../../components';
import { FiltersArea, MainContainer, TableActionArea } from '../../components';
import { SelectUpdatedHeader } from '../../components/SelectUpdatedHeader';
import { useManageComercialTableStore } from '../ManageComercialTable/ManageComercialTable.store';
import { useComercialTableList } from '../ManageComercialTable/hooks/useComercialTableList';
import { RetailConsultCurrentTable } from './components/RetailConsultCurrentTable';
import { useConsultComercialTableProductList } from './hooks/useConsultComercialTableProductList';
import { useConsultComercialTable } from '../ManageComercialTable/hooks/useConsultComercialTable';
import { useConsultComercialTableStore } from './ConsultComercialTable.store';
import { downloadTabelaComercialAtual } from './services';
import * as utils from '../../utils';
import { FilterNames } from '../../types';
import styles from './ConsultComercialTable.module.scss';
import { useCreateComercialTableStore } from '../CreateComercialTable/CreateComercialTable.store';
import { ComercialTablePriceLimitAndRulesTypes } from '../ManageComercialTable/types';

export const ConsultComercialTable = () => {
  const history = useHistory();
  const { comercialTableItem, comercialTablePriceLimitAndRules, setManageComercialTableState } = useManageComercialTableStore();

  const { consultComercialFiltersBody, setConsultComercialTableState } = useConsultComercialTableStore();

  const { comercialTableHeaderData, comercialTableMutateData } = useComercialTableList(1000);

  const {
    consultComercialTableProductData,
    consultComercialTableParams,
    setConsultComercialTableParams,
    handleChangeConsultarTabelaComercialLength,
    handleChangeConsultarTabelaComercialPage,
  } = useConsultComercialTableProductList();

  const { setConsultComercialTableID } = useConsultComercialTable();
  const { setCreateComercialTableState } = useCreateComercialTableStore();

  const handleSelectTableType = (id: number) => {
    const newItem = comercialTableMutateData.data.content.filter(item => item.id === id);
    setConsultComercialTableParams({
      ...consultComercialTableParams,
      idTabelaComercial: id,
    });
    setConsultComercialTableID(id);
    setManageComercialTableState('comercialTableItem', newItem[0]);
  };

  const handleClickDownload = () => {
    const id = comercialTableItem?.id;
    downloadTabelaComercialAtual(id);
  };

  const handleOnSelectFilter = (name: FilterNames, value: string[]) => {
    const objData = {
      ...consultComercialFiltersBody,
      [utils.filterNamesLabel[name]]: value,
    };
    setConsultComercialTableState('consultComercialFiltersBody', objData);
  };

  const handleOnCleanFilter = (name: FilterNames) => {
    const objData = {
      ...consultComercialFiltersBody,
      [utils.filterNamesLabel[name]]: [],
    };
    setConsultComercialTableState('consultComercialFiltersBody', objData);
    setConsultComercialTableParams({
      // chama a lista da tabela
      ...consultComercialTableParams,
      [utils.filterNamesLabel[name]]: [],
    });
  };

  const handleClickCleanFilters = () => {
    const objData = {
      descricao: [],
      familia: [],
      tier: [],
    };
    setConsultComercialTableState('consultComercialFiltersBody', objData);
    setConsultComercialTableParams({
      // chama a lista da tabela
      ...consultComercialTableParams,
      descricao: objData.descricao,
      familia: objData.familia,
      tier: objData.tier,
    });
  };

  const handleChangeTableByFilter = () => {
    setConsultComercialTableParams({
      // chama a lista da tabela
      ...consultComercialTableParams,
      descricao: consultComercialFiltersBody.descricao,
      familia: consultComercialFiltersBody.familia,
      tier: consultComercialFiltersBody.tier,
    });
  };

  const handleEditTableRules = (data: ComercialTablePriceLimitAndRulesTypes) => {
    setCreateComercialTableState('isCreateComercialTable', false);
    history.push(`/ipa/criar-tabela-comercial/${data.tabela.id}`);
  };

  useEffect(() => {
    if (typeof comercialTableItem?.id === 'number') {
      setConsultComercialTableParams({
        ...consultComercialTableParams,
        idTabelaComercial: comercialTableItem?.id,
      });
      setConsultComercialTableID(comercialTableItem?.id);
    }
  }, [comercialTableItem?.id]);

  return (
    <MainContainer>
      <div className={styles['header-wrapper']}>
        <div>
          <SelectUpdatedHeader
            isPending={comercialTableItem?.revisaoPendente}
            date={comercialTableItem?.atualizadoEm}
            value={comercialTableItem?.id}
            data={comercialTableHeaderData}
            onChange={handleSelectTableType}
          />
          <div className={styles['subtitle-wrapper']}>
            <p className={styles.subtitle}>As alterações são salvas automaticamente</p>
            <LinkButton fontSize="12px" onClick={() => handleEditTableRules(comercialTablePriceLimitAndRules)}>
              Editar regras da tabela
            </LinkButton>
          </div>
        </div>
        <Button className={styles['btn-consult']} onClick={() => history.push('/ipa/gerenciar-tabela-comercial')}>
          Editar tabela
        </Button>
      </div>
      <FiltersArea
        onSelect={handleOnSelectFilter}
        onClean={handleOnCleanFilter}
        onClose={handleChangeTableByFilter}
        onClickCleanFilters={handleClickCleanFilters}
      />
      <TableActionArea data={consultComercialTableProductData?.data}>
        <Button className={styles['btn-apply']} appearance="primary" onClick={handleClickDownload}>
          Download
        </Button>
      </TableActionArea>
      <RetailConsultCurrentTable
        data={consultComercialTableProductData}
        onChangePage={handleChangeConsultarTabelaComercialPage}
        onChangeLength={handleChangeConsultarTabelaComercialLength}
      />
    </MainContainer>
  );
};
